import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import axios from "axios";
import { useFormik } from "formik";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import * as yup from "yup";
import useCustomToast from "../../lib/useCustomToast";
import { ModalTitle } from "../card/ModalTitle";

const initialValues = {
  email: undefined,
};

export const ForgotPasswordModal = () => {
  const [loading, setLoading] = useState<boolean>(false);

  const toast = useCustomToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const loginType = queryParams.get("type") || "";

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: yup.object().shape({
      email: yup
        .string()
        .required("Email harus diisi")
        .email("Format email harus benar")
        .max(255, "Email tidak boleh lebih dari 255 karakter"),
    }),
    onSubmit: (values, { resetForm }) => {
      setLoading(true);

      axios
        .post(
          `${process.env.REACT_APP_API_URL}/v1/auth/${
            loginType === "supplier"
              ? `supplier`
              : loginType === "reseller"
              ? `reseller`
              : `buyer`
          }/forgot-password`,
          { email: values.email }
        )
        .then((res) => {
          toast({
            title: res.data.message,
            status: "success",
          });

          resetForm({ values: initialValues });
          onClose();
        })
        .catch((err) => {
          toast({
            title: err?.response?.data?.message || "",
          });
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });

  return (
    <>
      <Button
        variant={"ghost"}
        size={"xs"}
        fontSize={[10, null, 12]}
        fontWeight={"normal"}
        colorScheme="red"
        onClick={onOpen}
      >
        Lupa Password?
      </Button>

      <Modal isCentered isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <form
            id="forgotPasswordEmail"
            onSubmit={formik.handleSubmit}
            style={{ width: "100%" }}
          >
            <ModalBody textAlign={"center"}>
              <VStack w={"100%"}>
                <ModalTitle
                  title={`Lupa Password ${
                    loginType === "supplier"
                      ? `Supplier`
                      : loginType === "reseller"
                      ? `Reseller`
                      : `Buyer`
                  }?`}
                  subtitle="Masukkan email anda dan kami akan mengirimkan email reset password ke akun anda"
                />

                <FormControl
                  isInvalid={
                    formik.errors.email && formik.touched.email ? true : false
                  }
                >
                  <FormLabel htmlFor="email">Email</FormLabel>
                  <Input
                    name="email"
                    type="text"
                    placeholder="email@gmail.com"
                    onChange={formik.handleChange}
                    value={formik.values.email || ""}
                  />
                  <FormErrorMessage>{formik.errors.email}</FormErrorMessage>
                </FormControl>
              </VStack>
            </ModalBody>
            <ModalFooter>
              <Button
                variant={"ghost"}
                size={["xs", null, "sm"]}
                onClick={onClose}
              >
                Tutup
              </Button>

              <Button
                colorScheme="red"
                size={["xs", null, "sm"]}
                form="forgotPasswordEmail"
                isLoading={loading}
                loadingText="Loading"
                spinnerPlacement="start"
                type="submit"
              >
                Submit
              </Button>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>
    </>
  );
};
